module.exports = __webpack_public_path__ + "static/media/logo.ac88bf90.png";